module.exports = "https://static.wmbcdn.com/uniweb/images/a0d652f241fec8050ff9bc14931d1991.webp";